import { Endpoint } from '@business/api/endpoint';
import { CommissionTypeId, CommissionTypeRequest, CommissionTypeResponse } from '@business/entities/commission';

export function fetchCommissionTypes() {
  return Endpoint.get<CommissionTypeResponse[]>(`@gc/commission-types`);
}

export function createCommissionType(data: CommissionTypeRequest) {
  return Endpoint.post<CommissionTypeResponse[]>(`@gc/commission-types`, { data });
}

export function updateCommissionType(id: CommissionTypeId, data: CommissionTypeRequest) {
  return Endpoint.patch<CommissionTypeResponse[]>(`@gc/commission-types/${id}`, { data });
}

export function deleteCommissionType(id: CommissionTypeId) {
  return Endpoint.delete<{ success: boolean }>(`@gc/commission-types/${id}`);
}
